import { render, staticRenderFns } from "./InserirRelatorio.vue?vue&type=template&id=7b489769&lang=pug"
import script from "./InserirRelatorio.vue?vue&type=script&lang=js"
export * from "./InserirRelatorio.vue?vue&type=script&lang=js"
import style0 from "./InserirRelatorio.vue?vue&type=style&index=0&id=7b489769&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports